import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcLockDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.1013 10.3385H17.2566V7.76659C17.2566 5.13854 15.1185 3 12.4906 3C9.86177 3 7.72409 5.13825 7.72409 7.76659V10.3385H6.87971C6.39374 10.3385 6 10.7324 6 11.2182V19.9463C6 20.4321 6.39374 20.826 6.87971 20.826H18.1013C18.5863 20.826 18.981 20.4321 18.981 19.9463V11.2182C18.981 10.7324 18.5862 10.3385 18.1013 10.3385ZM9.48333 7.76659C9.48333 6.10809 10.8321 4.75929 12.4906 4.75929C14.1487 4.75929 15.4975 6.10809 15.4975 7.76659V10.3385H9.48333V7.76659Z",
		fill: "#3A3C45"
	})]
});
const ForwardRef = forwardRef(SvgIcLockDark);
export default ForwardRef;
